import React from 'react';
import DeviceSelector from '@/components/DeviceSelector';
import MoodSelector from '@/components/MoodSelector';
import NowPlayingWidget from '@/components/NowPlayingWidget';
import PlaybackControls from '@/components/PlaybackControls';
import PlaylistRecommender from '@/components/PlaylistRecommender';

/**
 * Main Dashboard View
 * The primary interface for music discovery and playback control
 */
const Dashboard: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Device Selector - Top Priority */}
      <section className="animate-fade-in">
        <DeviceSelector />
      </section>

      {/* Mood Selector */}
      <section className="animate-fade-in stagger-1">
        <MoodSelector />
      </section>

      {/* Playlist Discovery - Main Feature */}
      <section className="animate-fade-in stagger-2">
        <PlaylistRecommender />
      </section>

      {/* Now Playing */}
      <section className="animate-fade-in stagger-3">
        <NowPlayingWidget />
      </section>

      {/* Playback Controls */}
      <section className="animate-fade-in stagger-4">
        <PlaybackControls />
      </section>
    </div>
  );
};

export default Dashboard;
